import { useCallback } from "react";
import { useField } from "formik";
import { EfsMelcoEfsModelsMappingGroup } from "melco-shared-logic";

export const useFoldernameRules = () => {
  const [{ value: foldernameRules }, , { setValue: setFoldernameRules }] =
    useField<EfsMelcoEfsModelsMappingGroup[]>("folder_groups");

  const addFoldernameRule = useCallback(
    (foldernameRule: EfsMelcoEfsModelsMappingGroup) => {
      setFoldernameRules([...(foldernameRules ?? []), foldernameRule]);
    },
    [foldernameRules, setFoldernameRules]
  );

  const updateFoldernameRuleAtIndex = useCallback(
    (index: number, foldernameRule: EfsMelcoEfsModelsMappingGroup) => {
      setFoldernameRules(
        foldernameRules.map((fr, idx) => {
          if (idx === index) {
            return { ...foldernameRule };
          }

          return fr;
        })
      );
    },
    [foldernameRules, setFoldernameRules]
  );

  const removeFoldergroupRules = useCallback(
    (indicesToRemove: number[]) => {
      setFoldernameRules(
        foldernameRules.filter((_, idx) => !indicesToRemove.includes(idx))
      );
    },
    [foldernameRules, setFoldernameRules]
  );

  return {
    foldernameRules,
    addFoldernameRule,
    updateFoldernameRuleAtIndex,
    removeFoldergroupRules,
  };
};
